"use strict";
require('slick-carousel');

const Modules = () => {
    const init = () => {
        $(document).ready(function() {
            let ourApproach = document.getElementsByClassName('module-our-approach');
            if (ourApproach.length) {
                for(let i = 0; i < ourApproach.length; i++) {
                    ourApproachSlider(ourApproach.item(i));
                }
            }

            let testimonials = document.getElementsByClassName('module-testimonials');
            if (testimonials.length) {
                for(let i = 0; i < testimonials.length; i++) {
                    testimonialsSlider(testimonials.item(i));
                }
            }

            let portraitCarousel = document.getElementsByClassName('module-image-carousel-portrait');
            if (portraitCarousel.length) {
                for(let i = 0; i < portraitCarousel.length; i++) {
                    portraitCarouselSlider(portraitCarousel.item(i));
                }
            }

            let largeCarousel = document.getElementsByClassName('module-image-carousel-large');
            if (largeCarousel.length) {
                for(let i = 0; i < largeCarousel.length; i++) {
                    largeCarouselSlider(largeCarousel.item(i));
                }
            }
        });
    };

    const ourApproachSlider = (el) => {
        let $container = $(el);
        let $slider = $container.find('.slider').slick({
            infinite: false,
            adaptiveHeight: false,
            variableWidth: true,
            touchThreshold: 500,
            responsive: [
                {
                    breakpoint: 1640,
                    settings: {
                        infinite: true,
                    }
                }
            ]
        });

        $container.find('.js-slider-prev').click(function () {
            $slider.slick('slickPrev');
        });
        $container.find('.js-slider-next').click(function () {
            $slider.slick('slickNext');
        });
    };

    const testimonialsSlider = (el) => {
        let $container = $(el),
          $slider =  $container.find('.slider');
        $slider.slick({
            dots: true,
            infinite: true,
            speed: 1000,
            autoplaySpeed: 5000,
            fade: true,
            autoplay: false,
            cssEase: 'linear',
            adaptiveHeight: true,
            appendDots: $container.find('#dots'),
            touchThreshold: 500,
        });

        $('.testimonial-details').click(function() {
            let $this = $(this);
            let index = $this.data('index');
            $slider.slick('slickGoTo', index);
            $('.testimonial-details').removeClass('active');
            $this.addClass('active');
        });

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.testimonial-details').removeClass('active');
            $('.testimonial-details[data-index="' + nextSlide + '"]').addClass('active');
        });

    };

    const portraitCarouselSlider = (el) => {
        let $container = $(el),
          $slider =  $container.find('.slider');
        $slider.slick({
            infinite: true,
            slidesToShow: 5,
            autoplay: true,
            touchThreshold: 500,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        variableWidth: true,
                        slidesToShow: 2,
                        infinite: true,
                    }
                }
            ]
        });
    };

    const largeCarouselSlider = (el) => {
        let $container = $(el),
          $slider =  $container.find('.slider');
        $slider.slick({
            infinite: true,
            arrows: false,
            dots: true,
            touchMove: false,
            appendDots: $container.find('.pagination'),
            customPaging: function(slider, i) {
                return $("<span class='paginator'></span>");
            },
            touchThreshold: 500,
        });
    };

    return {
        init:init
    };
};

export default Modules;